import { ThemeModalProps } from "../../../../../types/UiKits";

const CommonThemeModalTitle:React.FC<ThemeModalProps> = ({ heading, subHeading, text }) => {
  return (
    <>
      <ul className="pb-3 pt-0">
        <li /><li /><li />
      </ul>
      <div className="pb-3 modal-heading">
        <h4 className="theme-name mb-0">
          <span>{heading}</span> {subHeading}
        </h4>
        <p className="text-gray">{text}</p>
      </div>
    </>
  );
};
export default CommonThemeModalTitle;
